{
	"columns":[
        {
			"header_id": "invoiceDate",
			"header_label": "Invoice Date",
			"jsonpath":  "invoiceDate" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "invoiceNumber",
			"header_label": "Invoice Number",
			"jsonpath":  "invoiceNumber" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "serviceDates",
			"header_label": "Service Dates",
			"jsonpath":  "serviceDates" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "n"
		},
		{
			"header_id": "consumerName",
			"header_label": "Participant Name",
			"jsonpath":  "consumerName" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "consumerPplId",
			"header_label": "Participant PPL ID",
			"jsonpath":  "consumerPplId" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "inProcessCount",
			"header_label": "In Process Service Lines",
			"jsonpath":  "inProcessCount" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "processedCount",
			"header_label": "Processed Service Lines",
			"jsonpath":  "processedCount" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "totalCost",
			"header_label": "Invoice Total Amount",
			"jsonpath":  "totalCost" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		}
    ],
	"buttons": [],
    "apiDetails": "providerinvoice.json",
	"pageName": "invoice-provider-inProcess",
	"orderByColumn": ["tasMasterPayrollScheduleId"],
	"orderBy": ["desc"]
}